var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12047 5.07679L11.5049 -0.00439453H10.4659L6.65893 4.40752L3.61829 -0.00439453H0.111267L4.70931 6.66721L0.111267 11.9956H1.1503L5.17059 7.33647L8.38172 11.9956H11.8887L7.12021 5.07679H7.12047ZM5.69737 6.72599L5.2315 6.06164L1.52467 0.775413H3.12056L6.11201 5.04157L6.57789 5.70591L10.4664 11.2513H8.87053L5.69737 6.72624V6.72599Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlack);
export default __webpack_public_path__ + "static/media/twitter-black.7c9b5e7e56648c6deda9a966ce816c9c.svg";
export { ForwardRef as ReactComponent };